import React, { useRef } from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { DateTime } from 'luxon'
import { useAppDispatch } from 'shared/hooks';
import { useAppSelector } from 'shared/hooks';
import { readMonitorRunByIdForMonitorRunResultDetail } from 'store/monitorRunResultSlice';
import { selectMonitorRunResultDetail } from 'store/monitorRunResultSlice';
import Toolbar from '@mui/material/Toolbar';
import { ReadMonitorRunByIdForMonitorRunResultDetailThunkParams } from 'store/monitorRunResultSlice';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList'
import Paper from '@mui/material/Paper'
import type { MonitorRunResultDetail } from 'shared/types'
import type { MonitorRunsResultDetailCard } from 'shared/types'
import { useReadMonitorRunsResultCardQuery } from 'services/monitorRunResult'

interface HeaderSectionProps {
    marketSpyId?: number
}

export const HeaderSection = (props: HeaderSectionProps): JSX.Element => {
    const {
        marketSpyId
    } = props

    const [open, setOpen] = useState(false)
    const prevOpen = useRef(open)
    const anchorRef = useRef<HTMLButtonElement>(null)
    const [readMonitorRunsResultCardParams, setReadMonitorRunsResultCardParams] = useState<any>(undefined)
    const [readMonitorRunsResultCardOptions, setReadMonitorRunsResultCardOptions] = useState<any>({
        skip: true
    })

    const {
        data: readMonitorRunsResultCardData,
        isLoading: readMonitorRunsResultCardIsLoading
    } = useReadMonitorRunsResultCardQuery(readMonitorRunsResultCardParams, readMonitorRunsResultCardOptions)

    const loading = false

    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [
        open
    ])

    useEffect(() => {
        setReadMonitorRunsResultCardParams((prev: any) => {
            return {
                ...prev,
                monitorId: marketSpyId
            }
        })

        setReadMonitorRunsResultCardOptions((prev: any) => {
            return {
                ...prev,
                skip: marketSpyId === undefined
            }
        })
    }, [
        marketSpyId
    ])

    const renderPeriod = () => {
        if (loading === false
            && readMonitorRunsResultCardData
            && readMonitorRunsResultCardData.firstRunDateTimeUTC
            && readMonitorRunsResultCardData.lastRunDateTimeUTC) {
            const dateTimeCheckIn = DateTime.fromISO(readMonitorRunsResultCardData.firstRunDateTimeUTC).toFormat('M/dd/yyyy');
            const dateTimeCheckOut = DateTime.fromISO(readMonitorRunsResultCardData.lastRunDateTimeUTC).toFormat('M/dd/yyyy');

            return (
                `${dateTimeCheckIn} - ${dateTimeCheckOut}`
            )
        }

        return (
            <>
                <Skeleton variant="text" width={270} height={50} animation={false} />
            </>
        )
    }

    return (
        <>
            <Toolbar sx={{
                bgcolor: '#648AAF',
                paddingRight: { xs: '12px', md: '24px' },
                paddingLeft: { xs: '12px', md: '24px' },
            }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Box component="h2" sx={{ fontWeight: '700', m: 0, color: '#FFF', fontSize: {xs: '24px' , md: '36px'} }}>
                        {readMonitorRunsResultCardData?.title }
                    </Box>
                </Box>
            </Toolbar>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom-start' ? 'left top' : 'left bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    id="composition-menu"
                                    aria-labelledby="composition-button"
                                    onKeyDown={handleListKeyDown}
                                >
                                    <MenuItem onClick={handleClose}>Share</MenuItem>
                                    <MenuItem onClick={handleClose}>Export</MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}